import { Global, Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { NotificationsModule } from '../notifications/notifications.module';
import { StoreProvisioningService } from '../merchant/store-provisioning.service';
import { AdminAccessGuard } from './admin-access.guard';
import { AuthController } from './auth.controller';
import { AuthGuard } from './auth.guard';
import { AuthRepository, PrismaAuthRepository } from './auth.repository';
import { SessionService } from './session.service';
import { SessionPruneService } from './session-prune.service';
import { AuthService } from './auth.service';
import { GoogleOAuthService } from './google-oauth.service';

@Global()
@Module({
  imports: [NotificationsModule],
  controllers: [AuthController],
  providers: [
    // Provided here rather than imported from MerchantModule: that module
    // already imports this one, so the dependency cannot run both ways. The
    // service holds no state, so a second instance costs nothing.
    StoreProvisioningService,
    AdminAccessGuard,
    AuthGuard,
    AuthService,
    GoogleOAuthService,
    SessionService,
    SessionPruneService,
    PrismaService,
    {
      provide: AuthRepository,
      useClass: PrismaAuthRepository,
    },
  ],
  exports: [AdminAccessGuard, AuthGuard, AuthRepository, AuthService, PrismaService, SessionService],
})
export class AuthModule {}
